import { render, staticRenderFns } from "./LegislacoesMunicipais.vue?vue&type=template&id=49a06306&"
import script from "./LegislacoesMunicipais.vue?vue&type=script&lang=js&"
export * from "./LegislacoesMunicipais.vue?vue&type=script&lang=js&"
import style0 from "./LegislacoesMunicipais.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports